import { provideComponent } from "scrivito"

import { MyProfileCardHeaderWidget } from "./MyProfileCardHeaderWidgetClass"
import "./styles/_my-profile-card-header-widget.scss"
import { MyProfileCardHeaderWidgetConnector } from "./ui/MyProfileCardHeaderWidgetConnector"

provideComponent(MyProfileCardHeaderWidget, MyProfileCardHeaderWidgetConnector)
